export const vipRegex = /(vip)|(lounger)/gi;
